module.exports = __webpack_public_path__ + "img/Close-2.b7c563f4.svg";